export default "__VITE_ASSET__05b686ad__"